module.exports = __webpack_public_path__ + "static/media/Attendence_Icon.17fed3c8.svg";